module.exports = __webpack_public_path__ + "static/media/work_image002.374886b7.jpg";